/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FastIlsInfo } from '../../models/fast-ils-info';

export interface IlsControllerDuplicateIls$Params {
  ilsId: string;
  destinationFolderId: string;
}

export function ilsControllerDuplicateIls(http: HttpClient, rootUrl: string, params: IlsControllerDuplicateIls$Params, context?: HttpContext): Observable<StrictHttpResponse<FastIlsInfo>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerDuplicateIls.PATH, 'post');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.path('destinationFolderId', params.destinationFolderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FastIlsInfo>;
    })
  );
}

ilsControllerDuplicateIls.PATH = '/ils/{ilsId}/duplicate/{destinationFolderId}';
